<template>
	<div class="AboutUs" v-if="!iswidth">
		<div style="max-width: 1600px; margin: auto; position: relative">
			<img @click="scrollToTop" class="topjiant" src="../assets/shj/top.png" alt="" srcset="" />
		</div>
		<div class="index-img" ref="bannerHeight">
			<div class="img">
				<el-carousel height="100%" autoplay>
					<el-carousel-item v-for="item in ImgUrls" :key="item.id">
						<img :src="$url + item.picture" alt="" srcset="" />
					</el-carousel-item>
				</el-carousel>
			</div>
		</div>
		<div class="news" v-if="CoList">
			<div class="news-box">
				<div ref="newsHeader" :class="
            show_box[0].show1
              ? 'news-header gymy unActive_box  active_box'
              : 'news-header gymy unActive_box'
          ">
					<img style="width: 100%" :src="$url + CoList[0].picture" alt="" srcset="" />
					<div class="myhead">
						<div>{{ CoList[0].name }}</div>
						<div style="font-size: 18px; margin: 10px 0px 20px 0">
							{{ CoList[0].sub_title }}
						</div>
					</div>
					<div :class="
              show_box[0].show2
                ? 'pomy-bo unActive_box active_box unActive_box_duration'
                : 'pomy-bo unActive_box'
            ">
						<div class="AboutUS" :style="
                show_box[0].show2
                  ? 'transform: translateX(0px);opacity:1'
                  : 'transform: translateX(-100px);opacity:0'
              ">
							<div class="AboutUS-title" v-if="language == false">关于我们</div>
							<div class="AboutUS-title" v-if="language == true">About Us</div>
							<div class="AboutUS-M">ABOUT US</div>
						</div>
						<img class="guanywmBj" style="" src="../assets/shj/biaoq.png" alt="" />
						<div class="pomy-bocont">
							<div v-html="CoList[0].content"></div>
						</div>
						<div class="pomy-button" @click="compay">MORE+</div>
					</div>
				</div>
				<div ref="Corepro" :class="
            show_box[0].show3
              ? 'news-header active_box unActive_boxF'
              : 'news-header unActive_boxF'
          ">
					<div class="Coreproducts">
						<div class="Coreproducts-info"
							:style="show_box[0].show11 ? 'opacity:1;transition: all 0.3s;' : 'opacity:0;transition: all 0.3s;'"
							v-if="Coproducts">
							<div :class="set_width === 1 ? 'Core-boxs2' : 'Core-boxs'"
								:style="show_box[0].show11 ? 'transform: translateX(0px);opacity:1;transition: all 0.3s;' : 'transform: translateX(-150px);opacity:0;transition: all 0.3s;'">
								<div class="Pemtitele">{{ Coproducts[0].name }}</div>
								<div class="newtitle">{{ Coproducts[0].contentList[0].title }}</div>
								<div style="" class="youjt" @click="setWidth(2)">
									<img src="../assets/shj/youjjant.png" alt="" srcset="" />
								</div>
								<div class="newphoto" style="">
									<div class="right-ul" v-html="Coproducts[0].content" style=""></div>
									<div>
										<img :src="Coproducts[0].picture ? $url + Coproducts[0].picture : 'https://cdn.shine-hydrogen.com/uploads/20241022/172958084367174f2b93a19zanwutupain.png'"
											style="width: 50%;
                     height: auto;" />
									</div>
								</div>
							</div>
							<div :class="set_width === 2 ? 'Core-boxs2 dianj' : 'Core-boxs dianj'"
								:style="show_box[0].show11 ? 'transform: translateX(0px);opacity:1;transition: all 0.3s;' : 'transform: translateX(150px);opacity:0;transition: all 0.3s;'">
								<div class="right-bg shi" style="">
									<div class="Pemtitele">{{ Coproducts[1].name }}</div>
									<div class="newtitle">{{ Coproducts[1].contentList[1].title }}</div>
									<div style="margin: 20px 0px 40px 0" class="youjt" @click="setWidth(1)">
										<img src="../assets/shj/youjjant.png" alt="" srcset="" />
									</div>
									<div class="right-ul" v-html="Coproducts[1].content" style="
                  "></div>
									<div class="pomy-button" @click="product">MORE+</div>
								</div>
								<div class="right-hxcp" style="">
									<!-- <img src='../assets/zanwutupain.png'/> -->
									<img :src="Coproducts[1].picture ? $url + Coproducts[1].picture : 'https://cdn.shine-hydrogen.com/uploads/20241022/172958084367174f2b93a19zanwutupain.png'"
										style="width: 50%;
                   height: auto;" />
								</div>
							</div>
						</div>
						<div v-if="language == false" class="shanghqTitle" :style="
                show_box[0].show3
                  ? 'transform: translateX(0px);opacity:1'
                  : 'transform: translateX(100px);opacity:0;'
              "> 核心产品 <img style="margin-left: 10px" src="../assets/shj/sant.png" alt="" srcset="" />
							<p class="Title-bottom">Core products</p>
						</div>
						<div v-if="language == true" class="shanghqTitle" :style="
                show_box[0].show3
                  ? 'transform: translateX(0px);opacity:1'
                  : 'transform: translateX(100px);opacity:0;'
              "> Core Products <img style="margin-left: 10px" src="../assets/shj/sant.png" alt="" srcset="" />
							<p class="Title-bottom">Core products</p>
						</div>
					</div>
				</div>
				<div ref="newCenter" :class="
            show_box[0].show4
              ? 'news-header unActive_box active_box'
              : 'news-header unActive_box'
          ">
					<div class="NewsCenter">
						<div class="Newsbgimg">
							<img src="../assets/shj/news.png" style="width: 100%" alt="" srcset="" />
						</div>
						<div v-if="language == false" class="shanghqTitle-Left" :style="
                show_box[0].show5
                  ? 'transform: translateX(0px);opacity:1'
                  : 'transform: translateX(-150px);opacity:0'
              ">
							<img style="margin-right: 10px" src="../assets/shj/sant.png" alt="" srcset="" /> 新闻中心 <p
								class="Title-bottom">NEWS CENTER</p>
						</div>
						<div v-if="language == true" class="shanghqTitle-Left" :style="
                show_box[0].show5
                  ? 'transform: translateX(0px);opacity:1'
                  : 'transform: translateX(-150px);opacity:0'
              ">
							<img style="margin-right: 10px" src="../assets/shj/sant.png" alt="" srcset="" /> News Center
							<p class="Title-bottom">NEWS CENTER</p>
						</div>
						<div class="pomy-button" @click="newsCeT">MORE+</div>
						<div class="news-left">
							<div class="news-leftInfo">
								<div v-for="(itemw, indexw) in NCenter" v-if="indexw < 3" :key="indexw"
									class="newsLeftC" :style="
                    show_box[0].show5
                      ? `transform: translateY(0px);opacity:1;transition: all 0.4s ease ${
                          indexw * 0.3
                        }s;`
                      : `transform: translateY(150px);opacity:0;transition:transition: all 0.4s ease ${
                          indexw * 0.3
                        }s`
                  " @click="Newsdetail(itemw.id)">
									<div class="nesTitle">
										{{ itemw.name }}
									</div>
									<div class="left-con">
										{{ itemw.sub_title }}
									</div>
									<div>
										<div style="color: rgba(153, 153, 153, 1)"></div>
										<div class="Newsleft-bottom">
											<div>{{ itemw.ctime }}</div>
											<div>
												<img src="../assets/shj/go.png" alt="" srcset="" />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="driendship">
			<div class="driendship-box">
				<div class="ContactUs">
					<div class="right">
						<div v-if="language == false" class="shanghqTitle-Left" :style="
                show_box[0].show5
                  ? 'transform: translateX(0px);opacity:1;color: white;'
                  : 'transform: translateX(-150px);opacity:0;color: white;'
              ">
							<img style="margin-right: 10px" src="../assets/shj/sant.png" alt="" srcset="" /> 联系我们 <p
								class="Title-bottom">Win win cooperation</p>
						</div>
						<div v-if="language == true" class="shanghqTitle-Left" :style="
                show_box[0].show5
                  ? 'transform: translateX(0px);opacity:1;color: white;'
                  : 'transform: translateX(-150px);opacity:0;color: white;'
              ">
							<img style="margin-right: 10px" src="../assets/shj/sant.png" alt="" srcset="" /> Contact Us
							<p class="Title-bottom">Win win cooperation</p>
						</div>
						<div v-for="(item, index) in ContUs" :key="index" class="right-bottom" :style="
                show_box[0].show5
                  ? `transform:translateX(0px);opacity:1;transition: all 0.4s ease ${
                      index * 0.2
                    }s;`
                  : `transform:translateX(-150px);opacity:0;transition: all 0.4s ease ${
                      index * 0.2
                    }s;`
              ">
							<div>
								<img style="width: 40px" src="../assets/shj/call.png" alt="" srcset="" />
							</div>
							<div class="right-bottom-center">
								<div>{{ item.name }}</div>
								<div style="font-weight: bold">{{ item.sub_title }}</div>
							</div>
							<div><img src="../assets/shj/gob.png" alt="" srcset="" /></div>
						</div>
					</div>
					<div class="left" :style="
              show_box[0].show10
                ? 'transform:translateX(0px);opacity:1;transition: all 0.4s;'
                : 'transform:translateX(-400px);opacity:0;transition: all 0.8s;'
            " v-if="ctivepartnerImg">
						<img :src="$url + ctivepartnerImg[0].picture" alt="" srcset="" />
					</div>
				</div>
			</div>
		</div>
	</div>
	<div v-else class="newphone">
		<div v-for="item in ImgUrls1">
			<img :src="$url + item.picture" alt="" />
		</div>
		<div class="newpbody">
			<div>
				<img :src="$url + CoList[0].picture" alt="" />
				<div>
					<div>{{ CoList[0].name }}</div>
					<div>
						{{ CoList[0].sub_title }}
					</div>
				</div>
			</div>
			<div class="newpabout">
				<div>
					<div>
						<div>{{ !language ? '关于我们': 'About Us'}}</div>
						<div>ABOUT US</div>
					</div>
				</div>
				<div v-html="CoList[0].content"></div>
				<div>
					<div @click="compay">MORE+</div>
				</div>
			</div>
			<div class="newpline"></div>
			<div class="newpcenter">
				<div>
					<img src="../assets/shj/sant.png" alt="" />
					<div>{{!language ? '核心产品' : 'Core products' }}</div>
				</div>
				<div class="newsproduct">
					<div class="newpcen">
						<div>{{ Coproducts[0].name }}</div>
						<div>{{ Coproducts[0].contentList[0].title }}</div>
						<img :src="$url + Coproducts[0].picture" alt="" />
					</div>
					<div class="newpcen" style="margin-top: 20px;">
						<div>{{ Coproducts[1].name }}</div>
						<div>{{ Coproducts[1].contentList[1].title }}</div>
						<img :src="$url + Coproducts[1].picture" alt="" />
					</div>
				</div>
			</div>
			<div class="newpline"></div>
			<div class="newpnews">
				<div>
					<img src="../assets/shj/sant.png" alt="" />
					<div>{{!language ? '新闻中心': 'News Center'}}</div>
				</div>
				<div class="newpcon">
					<div class="newpten" v-for="(item,index) in NCenter" v-if="index<3" :key="index"
						@click="Newsdetail(item.id)">
						<div>{{item.name}}</div>
						<div>{{item.sub_title}}</div>
						<div>
							<div>{{ item.ctime }}</div>
							<img src="../assets/shj/go.png" alt="" />
						</div>
					</div>
				</div>
			</div>
			<div class="newpline"></div>
			<div class="newpus">
				<div>
					<img src="../assets/shj/sant.png" alt="" />
					<div>{{ !language ? '联系我们' : 'Contact Us'}}</div>
				</div>
				<div class="newpico">
					<div class="newph" v-for="(item,index) in ContUs">
						<div>
							<img src="../assets/shj/call.png" alt="" />
							<div>
								<div>{{item.name}}</div>
								<div>{{item.sub_title}}</div>
							</div>
						</div>
						<div>
							<img src="../assets/shj/gob.png" alt="" srcset="" />
						</div>
						
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	import MessageCard from "./MessageCard.vue";
	import "swiper/css/swiper.css";
	import {
		reactive
	} from "vue";
	export default {
		components: {
			Swiper,
			SwiperSlide,
			MessageCard,
		},
		props: {
			lan: String,
		},
		data() {
			return {
				WebWidth: window.innerWidth,
				iswidth: false,
				procelIST: "",
				value: new Date(),
				swiperOption: {
					pagination: {
						el: ".swiper-pagination",
						clickable: true,
					},
					autoplay: {
						delay: 5000,
						pauseOnMouseEnter: true,
					},
					loop: true,
					navigation: {
						nextEl: ".swiper-button-next",
						prevEl: ".swiper-button-prev",
					},
				},
				switchImg: 1,
				switchPcr: 0,
				switchNews: 0,
				switchRes: 0,
				height: "",
				height1: "",
				list1: [],
				list2: [],
				list3: [],
				bannerList: [],
				bannerList2: [],
				id: 0,
				bannerHeight: "",
				ImgUrls: [],
				ImgUrls1: [],
				Pcrarr: [{}, {}, {}],
				idList: [0, 0, 0, 0],
				activeIndex: 0,
				windowHeight: 0,
				screenHeight: document.body.clientHeight, // 获取页面高度
				show_box: [{
					show1: true
				}, {
					show2: false
				}, {
					show3: false
				}, {
					show4: false
				}, {
					show5: false
				}, {
					show6: false
				}, {
					show7: false
				}, {
					show8: false
				}, {
					show9: false
				}, {
					show10: false
				}, ],
				CoList: null,
				Coproducts: null,
				NCenter: null,
				ctivepartner: null,
				ContUs: null,
				ctivepartnerImg: null,
				set_width: 1,
				language: false,
			};
		},
		watch: {
			lan(newValue, oldValue) {},
		},
		async mounted() {
			this.$emit("change", 1);
			this.height = (window.innerHeight * 1) / 2;
			this.height1 = (window.innerHeight * 1) / 3;
			window.onresize = () => {
				this.height = (window.innerHeight * 1) / 2;
				this.height1 = (window.innerHeight * 1) / 3;
			};
			await this.getList(3);
			await this.getList(1);
			await this.getList(2);
			await this.getList(0);
			await this.getBannerList();
			this.imglood();
			// fmini - title;
			window.addEventListener("resize",
				() => {
					this.bannerHeight = this.$refs.bannerHeight.offsetHeight;
					this.imglood();
				}, false);
		},
		mounted() {
			this.Browidth()
			window.addEventListener("resize", this.Browidth)
			this.language = localStorage.getItem("language") == 'English' ? true : false;
			this.ConsultationList();
			this.Carouselimage();
			this.Coreproducts();
			this.NewsCenter();
			this.cooperativepartner();
			this.ContactUs();
			this.cooperativepartnerImg();
			this.Carouselimages();
			this.getWindowHeight(); // 在初始化时获取窗口高度
			if (this.CoList) {}
			setTimeout(() => {}, 10);
		},
		created() {
			this.ConsultationList();
			this.Carouselimage();
			this.Coreproducts();
			this.NewsCenter();
			this.cooperativepartner();
			this.ContactUs();
			this.cooperativepartnerImg();
			this.ProductCenter();
			this.Carouselimages()
		},
		watch: {
			CoList: {
				handler(newValue, oldValue) {
					if (newValue) {
						console.log(newValue, "newValue");
						setTimeout(() => {
							window.addEventListener("resize", this.getWindowHeight); // 在窗口大小改变时重新获取窗度
							console.log(this.windowHeight);
							const newsHeader_height = this.$refs.newsHeader.getBoundingClientRect().top;
							if (newsHeader_height <= this.windowHeight) {
								this.show_box[0].show1 = true;
							}
							console.log(this.$refs.num);
							const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
							if (scrollTop >= newsHeader_height - 300) {
								this.show_box = this.show_box.map((item) => {
									item.show2 = true;
									return item;
								});
							}
							window.addEventListener("scroll", this.windowScroll);
						}, 10);
					}
				},
			},
		},
		methods: {
			Browidth() {
				this.WebWidth = window.innerWidth
				this.iswidth = this.WebWidth <= 500 ? true : false
				console.log(this.iswidth, 'iswidth');
			},
			setWidth(index) {
				this.set_width = index
				console.log(index)
			},
			// ProductCenter() {
			//   this.$http.post("/index/product/list", {
			//     page: 1,
			//     limit: 10,
			//   }).then((res) => {
			//     console.log(res.data.data,'111');
			//     this.procelIST = res.data;
			//     console.log(this.procelIST,'222')
			//   });
			// },
			windowScroll() {
				const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
				const newsHeaderTop = this.$refs.newsHeader.getBoundingClientRect().top - 400;
				const CoreproTop = this.$refs.Corepro.getBoundingClientRect().top - 400;
				const newCenterTop = this.$refs.newCenter.getBoundingClientRect().top + 400;
				// const cooperTop = this.$refs.cooper.getBoundingClientRect().top + 500;
				this.show_box = this.show_box.map((item) => {
					item.show2 = scrollTop >= newsHeaderTop;
					item.show3 = scrollTop >= CoreproTop;
					item.show4 = scrollTop >= newCenterTop;
					item.show5 = scrollTop >= newCenterTop;
					item.show6 = scrollTop >= newCenterTop + 750;
					item.show7 = scrollTop >= newCenterTop + 1200;
					item.show8 = scrollTop >= newCenterTop + 1600;
					item.show9 = scrollTop >= newCenterTop + 1800;
					item.show10 = scrollTop >= newCenterTop + 2000;
					item.show11 = scrollTop >= CoreproTop + 620
					return item;
				});
			},
			getWindowHeight() {
				this.windowHeight = window.innerHeight;
			},
			setActive(index) {
				this.activeIndex = index; // 设置当前激活的新闻项索引
			},
			open4() {
				this.$message({
					showClose: true,
					message: "无交易提示",
				});
			},
			compay() {
				this.$router.push({
					path: "/CompanyProfile"
				});
			},
			product() {
				this.$router.push({
					path: "/NewProductCenter"
				});
			},
			newsCeT() {
				this.$router.push({
					path: "/NewsCenter"
				});
			},
			Newsdetail(id) {
				this.$router.push({
					path: "/Newsdetail?id=" + id
				});
			},
			//返回顶部
			scrollToTop() {
				window.scrollTo({
					top: 0,
					behavior: "smooth"
				});
			},
			go2(id) {
				this.$router.push(`/datails?id=${id}`);
			},
			back(i, id) {
				// this.n = idx
				this.$router.push(i);
				this.drawer = false;
			},
			//轮播图
			Carouselimage() {
				this.$http.post("/index/banner/list", {
					id: !this.language ? "129" : "155",
				}).then((res) => {
					console.log(res.data.data);
					this.ImgUrls = res.data.data;
				});
			},
			Carouselimages() {
				this.$http.post("/index/banner/list", {
					id: !this.language ? "176" : "177",
				}).then((res) => {
					console.log(res.data.data);
					this.ImgUrls1 = res.data.data;
				});
			},
			//关于我们
			ConsultationList() {
				this.$http.post("/index/news/list", {
					id: !this.language ? "130" : "150",
				}).then((res) => {
					console.log(res.data.data);
					this.CoList = res.data.data;
				});
			},
			//核心产品
			Coreproducts() {
				this.$http.post("/index/product/list", {
					id: "22",
					language: !this.language ? "中文" : "英文",
				}).then((res) => {
					console.log(res.data.data);
					this.Coproducts = res.data.data;
					console.log(this.Coproducts, '111111111111111111')
				});
			},
			//新闻中心
			NewsCenter() {
				this.$http.post("/index/news/list", {
					id: !this.language ? "140" : "145",
				}).then((res) => {
					console.log(res.data.data, 1112);
					this.NCenter = res.data.data;
				});
			},
			//合作伙伴
			cooperativepartner() {
				this.$http.post("/index/banner/list", {
					id: "133",
				}).then((res) => {
					console.log(res.data.data);
					this.ctivepartner = res.data.data;
				});
			},
			//联系我们
			ContactUs() {
				this.$http.post("/index/news/list", {
					id: !this.language ? "134" : "149",
				}).then((res) => {
					console.log(res.data.data);
					this.ContUs = res.data.data;
				});
			},
			//联系我们图片
			cooperativepartnerImg() {
				this.$http.post("/index/banner/list", {
					id: "136",
				}).then((res) => {
					console.log(res.data.data);
					this.ctivepartnerImg = res.data.data;
				});
			},
		},
	};
</script>
<style>
	html {
		overflow-x: hidden;
	}

	.topjiant {
		position: fixed;
		bottom: 100px;
		right: 0px;
		z-index: 999999;
	}

	.active_box {
		transform: translateX(0) !important;
		opacity: 1 !important;
	}

	.unActive_box {
		transition: all 0.4s;
		transform: translateX(180px);
		opacity: 0;
	}

	.unActive_boxF {
		transition: all 0.4s;
		transform: translateX(-180px);
		opacity: 0;
	}

	.unActive_box_duration {
		transition-duration: 0.5s;
	}

	.right-hxcp {
		display: flex;
		align-items: center;
		justify-content: center;

		@media (max-width: 800px) {
			margin-top: 40px;
		}
	}

	.AboutUS {
		position: absolute;
		margin-top: 10px;
		margin-left: 10px;
		transition: all 0.4s;
		transition-duration: 0.4s;

		@media (max-width:800px) {
			margin-left: -5px;
		}
	}

	ul {
		padding-left: 10px;
	}

	.guanywmBj {
		margin-left: -52px;
		width: 200px;

		@media (max-width:800px) {
			width: 150px;
		}
	}

	.AboutUS-title {
		font-size: 24px;
		color: white;
		font-weight: bold;

		@media (max-width:800px) {
			font-size: 18px;
		}
	}

	.AboutUS-M {
		color: rgb(253, 252, 252);
		opacity: 0.5;
		font-size: 12px;
	}

	.el-calendar-table .el-calendar-day {
		height: 50px !important;
	}

	.el-calendar__body {
		padding: 12px 20px 0px 20px;
	}

	@media only screen and (max-width: 800px) {
		.el-calendar-table .el-calendar-day {
			height: 30px !important;
		}

		.el-calendar__title {
			font-size: 14px;
		}

		.el-message {
			min-width: 200px !important;
		}
	}

	.img-box-centent p {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		margin: 0;
		display: initial;
		text-indent: 0;
	}

	.img-box-centent p:after {
		content: "...";
		position: absolute;
		bottom: 0;
		right: 0;
		height: 100%;
		width: 100%;
		z-index: 1;
	}

	.img-box-centent p:not(:first-child) {
		display: none;
	}

	.img-box-centent div {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		pointer-events: none;
		margin: 0;
		display: initial;
		text-indent: 0;
	}

	.img-box-centent div:after {
		content: "...";
		position: absolute;
		bottom: 0;
		right: 0;
		height: 100%;
		width: 100%;
		white-space: nowrap;
		z-index: 1;
	}

	.img-box-centent div:not(:first-child) {
		display: none;
	}

	/* .el-carousel__container {
  background-color: #f9f9f9;
  @media (min-width: 1440px) {
    height: 550px !important;
  }

  @media (max-width: 1200px) {
    height: 350px !important;
    margin: auto;
  }
  @media (max-width: 800px) {
    height: 150px !important;
    margin: auto;
  }
  @media (max-width: 300px) {
    height: 100px !important;
    margin: auto;
  }
} */
</style>
<style lang="scss" scoped>
	.newphone {
		background-color: #f5f5f5;
		font-size: 18px;

		>div:first-child {
			display: flex;
			width: 100%;

			img {
				width: 100%;
			}
		}

		.newpbody {
			display: flex;
			padding: 20px;
			flex-direction: column;
			margin-bottom: 10px;
			>div:first-child {
				position: relative;

				img {
					width: 100%;
				}

				>div {
					position: absolute;
					top: 0;
					left: 0;
					background-color: rgba(70, 70, 70, .5);
					color: #fff;
					padding: 10px;

					>div:first-child {
						font-size: 16px;
						margin: 5px 0;
					}

					>div:last-child {
						font-size: 14px;
						margin: 5px 0;
					}
				}
			}

			.newpabout {
				display: flex;
				flex-direction: column;
				margin-top: 20px;

				>div:first-child {
					display: -webkit-box;
					-webkit-box-orient: none;
					flex-direction: column;

					>div:first-child {
						display: flex;
						flex-direction: column;
						padding: 10px 30px;
						background-color: #007aff;
						color: #fff;
						align-items: center;

						>div:first-child {
							font-size: 18px;
							font-weight: bold;
							margin: 1px 0;
						}

						>div:last-child {
							font-size: 12px;
							color: #fdfcfc;
							margin: 1px 0;
						}
					}
				}

				>div:nth-child(2) {
					font-size: 16px;
					line-height: 1.4em;
				}

				>div:last-child {
					display: -webkit-box;
					-webkit-box-orient: none;

					>div {
						display: flex;
						padding: 5px 10px;
						color: #fff;
						font-size: 16px;
						align-items: center;
						background: -webkit-linear-gradient(left,
								rgba(65, 186, 1, 1),
								rgba(0, 113, 211, 1));
					}
				}
			}

			.newpline {
				margin: 20px 0;
				height: 2px;
				background: -webkit-linear-gradient(left,
						rgba(65, 186, 1, 1),
						rgba(0, 113, 211, 1));
			}

			.newpcenter {
				>div:first-child {
					display: flex;
					align-items: center;
					font-size: 20px;
					font-weight: bold;
					color: #000;

					img {
						height: 24px;
						width: 2px;
						margin-right: 10px;
					}
				}

				.newsproduct {
					margin-top: 10px;
					padding: 0 10px;

					.newpcen {
						>div:first-child {
							font-size: 18px;
							font-weight: 700;
							color: #000;
							margin-bottom: 10px;
						}

						>div:nth-child(2) {
							font-size: 16px;
							margin-bottom: 10px;
						}

						img {
							width: 50%;
						}
					}
				}
			}

			.newpnews {
				>div:first-child {
					display: flex;
					align-items: center;
					font-size: 20px;
					font-weight: bold;
					color: #000;

					img {
						height: 24px;
						width: 2px;
						margin-right: 10px;
					}
				}

				.newpcon {
					.newpten {
						margin-top: 10px;
						padding: 0 10px;
						>div:first-child{
							font-size: 18px;
							font-weight: 700;
							line-height: 1.6em;
							margin-bottom: 10px;
						}
						>div:nth-child(2){
							font-size: 16px;
							font-weight: 400;
							line-height: 1.5em;
							margin-bottom: 10px;
							text-align: justify;
						}
						>div:last-child{
							font-size: 16px;
							font-weight: 400;
							line-height: 1.5em;
							display: flex;
							align-items: center;
							justify-content: space-between;
						}
					}
				}
			}
			.newpus{
				background-image: url('../assets/shj/Contact.png');
				padding: 50px 20px;
				>div:first-child {
					display: flex;
					align-items: center;
					font-size: 20px;
					font-weight: bold;
					color: #fff;
				
					img {
						height: 24px;
						width: 2px;
						margin-right: 10px;
					}
				}
				.newpico{
					.newph{
						margin-top: 30px;
						display: flex;
						align-items: center;
						justify-content: space-between;
						>div:first-child{
							display: flex;
							align-items: center;
							img{
								width: 40px;
								margin-right: 20px;
							}
							>div{
								font-size: 16px;
								color: #fff;
								font-weight: 700px;
							}
						}
					}
				}
			}
		}
	}

	.nesTitle {
		font-weight: bold;
		line-height: 30px;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 2;
		overflow: hidden;
	}

	.hezhb {
		@media (max-width: 800px) {
			display: none;
		}
	}

	.youjt {
		margin: 20px 0px 40px 0;

		@media (max-width: 800px) {
			display: none;
		}
	}

	.Core-boxs {
		box-shadow: 5px 0px 12px rgba(0, 113, 211, 0.2);

		@media (max-width: 800px) {
			box-shadow: none;
		}
	}

	.dianj {
		display: flex;
		width: 100% !important;
		box-shadow: 5px 0px 15px rgba(0, 113, 211, 0.2);
		margin-left: 20px;

		@media (max-width: 800px) {
			flex-wrap: wrap;
			box-shadow: none;
			margin-left: 0;
		}

		.pomy-button {
			@media (max-width: 800px) {
				display: none;
			}

			cursor: pointer;
		}

		&:hover .pomy-button {
			cursor: pointer;
		}
	}

	.shanghqTitle-Left {
		display: flex;
		align-items: center;
		font-size: 32px;
		position: relative;
		margin: 20px 0 30px 0;
		transition: all 0.4s;

		// transition-duration: 0.7s;
		// transition: all 0.4s ease 0.7s;
		@media (max-width: 800px) {
			font-size: 18px;
		}

		img {
			@media (max-width: 800px) {
				width: 2px;
				height: 30px;
			}
		}

		.Title-bottom {
			opacity: 0.1;
			position: absolute;
			font-size: 26px;
			bottom: -36px;
			left: 16px;

			@media (max-width: 800px) {
				font-size: 16px;
				bottom: -16px;
			}
		}
	}

	.shanghqTitle {
		position: absolute;
		right: 0;
		display: flex;
		align-items: center;
		font-size: 32px;
		top: 30px;
		transition: all 0.4s;
		transition-duration: 0.7s;

		@media (max-width: 800px) {
			font-size: 18px;
		}

		img {
			@media (max-width: 800px) {
				width: 2px;
				height: 30px;
			}
		}

		.Title-bottom {
			opacity: 0.1;
			position: absolute;
			// width: 400px;
			left: -90px;
			top: -4px;
			letter-spacing: 3px;
			font-size: 26px;

			@media (max-width: 800px) {
				font-size: 16px;
				top: 8px;
				left: -60px;
			}
		}
	}

	.shi {
		margin-right: 10%;

		@media (max-width: 800px) {
			margin-right: 0%;
			margin-bottom: 10px;
		}
	}

	.right-ul {
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		width: calc(100% - 20px);
		max-width: your-desired-width-20px;

		@media (max-width:800px) {
			width: 150px;
		}

		>li {
			line-height: 30px;

			@media (max-width: 800px) {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				line-height: 30px;
			}

			@media (max-width: 1440px) {
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 2;
				overflow: hidden;
				line-height: 30px;
			}
		}
	}

	.pomy-bocont {
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 4;
		overflow: hidden;
	}

	.left-con {
		@media (max-width: 800px) {
			display: -webkit-box;
			-webkit-box-orient: vertical;
			-webkit-line-clamp: 2 !important;
			overflow: hidden;
			line-height: 30px;
		}
	}

	.right-bg {
		width: 40%;

		@media (max-width: 800px) {
			width: 100%;
			margin-top: 10px;
		}
	}

	.Coreproducts {
		.shanghqTitle {
			@media (min-width: 540px) and (max-width: 800px) {
				top: 0;
			}
		}
	}

	.gymy {
		// background: url("../assets/shj/aboutBj.png") no-repeat;
		height: 500px;
		background-size: cover;
		position: relative;

		// height: 100%;
		@media (max-width: 800px) {
			// padding: 20px 10px;
			height: 740px;
		}

		@media (min-width: 540px) and (max-width: 680px) {
			// padding: 20px 10px;
			height: 700px;
		}

		@media (max-width: 540px) {
			// padding: 20px 10px;
			height: 620px;
		}

		.myhead {
			color: white;
			font-weight: bold;
			font-size: 24px;
			padding: 80px 80px;
			position: absolute;
			top: 0;
			background-color: rgba(70, 70, 70, 0.5);
		}

		.pomy-bo {
			background: white;
			// width: 620px;
			// margin-top: 20px;
			margin-left: 38%;
			margin-right: 10%;
			padding: 20px 40px;
			box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
			position: absolute;
			bottom: -100px;

			@media (max-width: 800px) {
				bottom: 0px;
				position: relative;
				box-sizing: border-box;
			}

			@media (max-width: 1440px) {
				margin-left: 0%;
				margin-right: 0%;
			}

			.pomy-bocont {
				line-height: 30px;
				margin-bottom: 40px;
			}
		}
	}

	.pomy-button {
		padding: 6px 14px;
		width: 60px;
		color: white;
		margin-top: 20px;
		background: -webkit-linear-gradient(left,
				rgba(65, 186, 1, 1),
				rgba(0, 113, 211, 1));
		cursor: pointer;
	}

	.pomy-bo::after {
		content: "";
		display: block;
		width: 100%;
		height: 2px;
		background: linear-gradient(to right,
				rgba(65, 186, 1, 1),
				rgba(0, 113, 211, 1));
		position: absolute;
		bottom: 0;
		left: 0;
	}

	.Coreproducts {
		background: url("../assets/shj/bg_b.png") no-repeat;
		margin-top: 200px;
		width: 600px;
		height: 700px;

		@media (max-width: 800px) {
			height: 580px;
		}

		.Coreproducts-info {
			background: white;
			position: absolute;
			display: flex;
			justify-content: space-between;
			width: 96%;
			margin-left: 4%;
			// margin-top: 12%;
			top: 50%;
			transform: translateY(-50%);

			@media (max-width: 600px) {
				margin-top: 10%;
			}

			// height: 67%;
			// padding: 20px 20px;
			@media (max-width: 800px) {
				padding: 20px 10px;
				margin-left: 0%;
				flex-wrap: wrap;
				margin-top: 276px;
			}

			.Pemtitele {
				font-size: 28px;

				@media (max-width:800px) {
					font-size: 18px;
					font-weight: bold;
					margin-top: 10px;
				}
			}

			.newtitle {
				@media (max-width:800px) {
					margin-top: 10px;
					font-size: 16px;
				}
			}

			.newphoto {
				display: flex;
				align-items: center;
				justify-content: center;

				@media (max-width:800px) {
					display: flex;
					align-items: flex-start;
					justify-content: flex-start;
				}
			}

			>div:nth-child(1) {
				width: 20%;
				transition: width 2s;
			}

			>div {
				padding: 30px 30px;
				box-sizing: border-box;

				@media (max-width: 800px) {
					font-size: 16px;
					padding: 0;
					display: flex !important;
					justify-content: flex-start;
					flex-wrap: wrap;
					// justify-content: space-between;
					width: 100% !important;
					align-items: center;
					// margin-top: 200px;
				}
			}

			>div:nth-child(2) {
				width: 40%;
			}

			>div:last-child {
				width: 40%;
			}
		}
	}

	.right-hxcp {
		display: flex;
		justify-content: center;
		width: 80%;
		margin: 10px auto;
		transition: all 0.3s;

		img {
			transition: all 0.3s;
			width: 80%;
		}

		&:hover img {
			transform: scale(1.1);
		}

		@media (max-width: 800px) {
			img {
				width: 100%;
			}
		}
	}

	@media (max-width: 800px) {
		.myhead {
			padding: 10px !important;
			font-size: 16px !important;

			// display: none;
			>div:nth-child(2) {
				font-size: 14px !important;
				margin: 4px 0 10px 0;
			}

			img {
				width: 30px;
			}
		}

		.pomy-bo {
			// width: 276px !important;
			margin-left: 0px !important;
			// padding: 0px 40px !important;
			// height: 360px !important;
			margin-right: 0 !important;
			max-height: 320px;
			overflow: hidden;
		}

		.Coreproducts {
			margin-top: -320px;
			background: none;
		}

		.pomy-bocont {
			margin-bottom: 10px !important;
		}
	}

	.NewsCenter {
		background: rgba(241, 245, 249, 1);
		padding: 40px 40px;
		// height: 700px;
		position: relative;
		z-index: 2;

		.pomy-button {
			@media (max-width: 800px) {
				display: none;
			}
		}

		&:hover .pomy-button {
			cursor: pointer;
		}

		@media (max-width: 300px) {
			background: none;
			padding: 0;
			height: 200px !important;
		}

		@media (min-width: 300px) and (max-width: 600px) {
			background: none;
			padding: 0;
			height: 300px !important;
			margin-top: 265px;
		}

		@media (min-width: 600px) and (max-width: 800px) {
			background: none;
			padding: 0;
			height: 320px;
		}

		.Newsbgimg {
			// background: url("../assets/shj/xinwzx.png") no-repeat;
			width: 100%;
			object-fit: cover;
			// height: 400px;
			background-size: 100% 100%;

			@media (max-width: 800px) {
				background: none;
				// display: none;
				// height: 400px;
				position: absolute;
				bottom: 66px;
			}
		}

		.news-left {
			position: absolute;
			top: 44%;
			left: 37%;

			@media (max-width: 800px) {
				top: 10%;
				left: 0;
			}

			.news-leftInfo {
				display: flex;

				@media (max-width: 800px) {
					flex-wrap: wrap;
				}
			}
		}

		.newsLeftC {
			width: 240px;
			padding: 20px 20px;
			background: white;
			margin-right: 30px;
			box-shadow: 5px 6px 20px rgba(29, 143, 236, 0.1);
			transition: all 0.5s ease-in-out;
			display: flex;
			flex-flow: column;
			justify-content: space-around;

			&:hover {
				background: rgb(230, 243, 253);
				background-image: url("../assets/shj/newsK.png");
				transform: translateY(-50px) !important;
				background-repeat: no-repeat;
				background-size: 100% 100%;
				transition: 0.3s ease-in-out 0s !important;

				@media (max-width: 800px) {
					transform: translateY(0px);
				}
			}

			@media (max-width: 1440px) {
				width: 100%;
			}

			@media (max-width: 800px) {
				width: 100%;
				margin-right: 0px;
				margin-bottom: 6px;
			}

			.left-con {
				margin: 20px 0;
				font-size: 14px;
				line-height: 30px;
				display: -webkit-box;
				-webkit-box-orient: vertical;
				-webkit-line-clamp: 5;
				overflow: hidden;

				@media (max-width: 1440px) {
					display: -webkit-box;
					-webkit-box-orient: vertical;
					-webkit-line-clamp: 4;
					overflow: hidden;
					margin: 0 0;
				}

				@media (max-width: 800px) {
					margin: 10px 0 !important;
				}
			}

			.Newsleft-bottom {
				display: flex;
				justify-content: space-between;
			}
		}

		.news-active {
			// background: rgb(230, 243, 253);
			// background-image: url("../assets/shj/newsK.png");
			// transform: translateY(-50px);
			// background-repeat: no-repeat;
			// background-size: 100% 100%;
			// transition: transform 0.5s ease-in-out;
			// @media (max-width: 800px) {
			//   transform: translateY(0px);
			// }
		}
	}

	.cooperativepartner {
		// background: url("../assets/shj/bg_c.png") no-repeat;
		width: 100%;
		height: 500px;
		position: relative;
		// top: -80px;
		z-index: 1;
		background-size: cover;

		@media (max-width: 800px) {
			background: none;
			margin-top: 450px;
			height: 100%;
			margin-bottom: 20px;
		}

		@media (max-width: 727px) {
			background: none;
			margin-top: 450px;
			height: 340px;
		}

		@media (max-width: 549px) {
			background: none;
			margin-top: 450px;
			height: 440px;
		}

		@media (max-width: 365px) {
			background: none;
			margin-top: 450px;
			// height: 700px;
		}

		.cooperativepC {
			padding: 80px 120px;
			position: absolute;
			top: 0px;

			// @media (max-width: 1440px) {
			//   padding: 80px 0px;
			// }
			@media (max-width: 800px) {
				display: flex;
				flex-wrap: wrap;
				padding: 80px 0px 0px 0;
				justify-content: space-between;
				position: static;
			}

			>div {
				border: 1px solid rgba(203, 221, 235, 1);
				width: 160px;
				height: 70px;
				padding: 20px 20px;
				position: relative;
				background: white;
				display: flex;
				align-items: center;
				top: 20px;
				cursor: pointer;
				transition: all 0.2s;
				opacity: 0.9;

				&:hover {
					transition: all 0.2s;
					// transform: translateY(-10px) !important;
					background-image: url("../assets/shj/newsK.png");
					background-size: 100% 100%;
					opacity: 1;
					background-repeat: no-repeat;
					// border: 1px solid red;
				}

				@media (max-width: 800px) {
					position: static;
					margin-bottom: 20px;
					box-sizing: border-box;
					width: 150px !important;
					height: 70px !important;
				}

				@media (max-width: 1440px) {
					width: 100px;
					height: 40px;
				}

				img {
					width: 100%;
				}
			}

			> :nth-child(1) {
				top: 20px;

				@media (max-width: 1440px) {
					top: 0px;
				}
			}

			> :nth-child(2) {
				left: 300px;
				top: 0px;

				@media (max-width: 1440px) {
					left: 220px;
					top: -40px;
				}
			}

			> :nth-child(3) {
				left: 620px;
				top: -200px;

				@media (max-width: 1440px) {
					left: 440px;
					top: -200px;
				}
			}

			> :nth-child(4) {
				left: 780px;
				top: -230px;

				@media (max-width: 1440px) {
					left: 560px;
					top: -220px;
				}
			}

			> :nth-child(5) {
				left: 1100px;
				top: -280px;

				@media (max-width: 1440px) {
					left: 700px;
					top: -200px;
				}
			}

			> :nth-child(6) {
				left: 600px;
				top: -300px;

				@media (max-width: 1440px) {
					left: 440px;
					top: -280px;
				}
			}

			> :nth-child(7) {
				left: 160px;
				top: -380px;

				@media (max-width: 1440px) {
					top: -340px;
					left: 120px;
				}
			}
		}
	}

	.AboutUs {
		width: 100%;
		background-color: #f9f9f9;

		.index-img {
			width: 100%;
			height: auto;
			cursor: pointer;

			// justify-content: center;
			.img {
				height: 31vw;

				@media (max-width: 800px) {
					height: 51vw;
				}

				div {
					height: 100%;
				}

				img {
					display: block;
					width: 100%;
					height: auto;
					margin-top: -100px;

					@media (max-width: 800px) {
						height: 51vw;
						margin-top: 0;
					}

					// @media (max-width: 1440px) {
					//   height: 400px;
					// }
					// @media (max-width: 1200px) {
					//   width: 100%;
					//   height: 350px;
					//   // display: flex;
					//   margin: auto;
					//   overflow: hidden;
					// }
					// @media (max-width: 800px) {
					//   width: 100%;
					//   height: 150px;
					//   // display: flex;
					//   margin: auto;
					//   overflow: hidden;
					// }
					// @media (max-width: 300px) {
					//   height: 100px;
					// }
				}
			}
		}

		// .index {
		//   display: block;
		//   @media (max-width: 1199px) {
		//     display: none;
		//   }
		// }
		// .indexx {
		//   display: none;
		//   @media (max-width: 1199px) {
		//     display: block;
		//   }
		// }
		.products {
			@media (max-width: 1440px) {
				// max-width: 1200px;
				width: 100%;
				height: auto;
				// padding-bottom: 115px;
				/* margin-top: 100px; */
			}

			@media (max-width: 1200px) {
				// width: 100%;
				overflow: hidden;
				height: auto;
			}

			@media (max-width: 800px) {
				// width: 100%;
				height: auto;
				padding-bottom: 0;
			}

			.products-box {
				@media (max-width: 1440px) {
					width: 100%;
					margin: auto;
					height: auto;
				}

				@media (max-width: 1200px) {
					width: 100%;
					margin: auto;
					height: auto;
				}

				@media (max-width: 800px) {
					// max-width: 450px;
					width: 90%;
					// padding-bottom: 40px;
					margin: 0 auto;
					height: auto;
				}

				@media (max-width: 800px) {
					padding-top: 0;
				}

				.products-hander {
					@media (max-width: 1650px) {
						width: 100%;
						max-width: 1600px;
						// height: 1500px;
						margin: 0 auto;
					}

					@media (max-width: 1440px) {
						padding-top: 0;
						width: 100%;
						max-width: 1600px;
						margin: 0 auto;
						// height: auto;
					}

					@media (max-width: 1200px) {
						padding-top: 10px;
						width: 100%;
						max-width: 1600px;
						margin: 0 auto;
						// height: 170px;
					}

					@media (max-width: 800px) {
						width: 100%;
						margin: 15px auto 0;
					}

					// position: relative;
					.fast-track-box {
						display: flex;
						// position: absolute;
						background-color: rgba(0, 0, 0, 0.6);
						width: 100%;
						height: 100px;
						z-index: 10000;
						// border: 1px solid #f1f1f1;
						box-shadow: 0px 5px 10px 1px rgba(0, 0, 0, 0.1);
						transition: all 0.6s;

						.fast-info {
							display: flex;
							justify-content: space-between;
							align-items: center;
							max-width: 1600px;
							width: 100%;
							margin: 0 auto;
							color: white;
							font-size: 12px;

							// flex-wrap: wrap;
							.text {
								width: 100%;
								background: -webkit-linear-gradient(left,
										rgba(65, 186, 1, 1),
										rgba(0, 113, 211, 1));
								-webkit-text-fill-color: transparent;
								-webkit-background-clip: text;
								font-size: 32px;
								font-weight: bold;
							}

							.pro-text {
								width: 100%;
							}
						}

						@media (max-width: 800px) {
							.fast-info {
								flex-wrap: wrap;

								div {
									width: 50%;
									text-align: center;
								}
							}
						}

						@media (max-width: 1440px) {
							width: 100%;
							height: 100px;
							// margin-bottom: 30px;
							transition: all 0.3s linear;
							// top: -265px;
						}

						@media (max-width: 960px) {
							width: 100%;
							// height: 140px;
							transition: all 0.3s linear;
							top: 268px !important;
							z-index: 12;
							position: absolute;
						}

						@media (max-width: 870px) {
							width: 100%;
							// height: 140px;
							transition: all 0.3s linear;
							top: 238px !important;
							z-index: 12;
							position: absolute;
						}

						@media (max-width: 1200px) {
							width: 100%;
							// height: 140px;
							transition: all 0.3s linear;
							top: 328px;
							z-index: 12;
							position: absolute;
						}

						@media (max-width: 800px) {
							position: static;
							width: 99%;
							height: 240px;
							transition: all 0.3s linear;
							top: -140px;
						}

						@media (max-width: 800px) {
							// margin-bottom: 15px;
						}

						position: relative;
						top: -100px;
						left: 0px;

						.fast-track-left {
							width: 220px;
							height: 100%;
							display: flex;
							justify-content: center;
							align-items: center;
							cursor: pointer;

							@media (max-width: 1200px) {
								display: none;
							}

							.kstd {
								width: 68px;
								height: 80px;
								display: flex;
								justify-content: center;

								// align-items: center;
								// @media (max-width: 1600px) {
								//   width: 54px;
								//   height: 64px;
								// }
								span {
									font-size: 30px;
									color: #bc0015;
									font-weight: Bold;
									font-family: Microsoft YaHei, Microsoft YaHei !important;
									// @media (max-width: 1600px) {
									//   font-size: 24px;
									// }
								}
							}
						}

						// 小竖条
						.fast-track-center {
							display: flex;
							align-items: center;

							@media (max-width: 1200px) {
								display: none;
							}

							.box-center {
								width: 2px;
								height: 192px;
								background-color: #bebebe;
								opacity: 0.38;

								@media (max-width: 1200px) {
									height: 400px;
								}

								@media (max-width: 800px) {
									height: 300px;
								}
							}
						}

						.fast-track-right {
							display: flex;
							justify-content: center;
							align-items: center;
							justify-content: space-around;
							width: 100%;
							height: 100%;

							// background-color: aliceblue;
							@media (max-width: 1200px) {
								width: 100%;
								display: flex;
								justify-content: center;
								align-items: center;
								flex-wrap: wrap;
							}

							@media (max-width: 1200px) {
								width: 100%;
							}

							.click-box {
								width: 100%;
								cursor: pointer;
								display: flex;
								flex-direction: column;
								justify-content: center;
								align-items: center;
								text-align: center;

								@media (max-width: 1200px) {
									width: 33%;
									height: 50%;
								}

								// @media (max-width: 800px) {
								//   width: 33%;
								//   height: 50%;
								// }
								// border: 1px solid darkgreen;
								img {
									width: 88px;
									height: 88px;

									// display: flex;
									// align-content: center;
									// justify-content: center;
									@media (max-width: 1200px) {
										width: 88px;
										height: 88px;
									}

									@media (max-width: 800px) {
										width: 60px;
										height: 60px;
									}

									@media (max-width: 300px) {
										width: 45px;
										height: 45px;
									}

									// 上浮
									transition: transform 0.5s ease;
									max-width: 100%;
								}

								.span-title {
									// width: 100%;
									// position: absolute;
									// top: 100px;
									// left: 7.5px;
									font-family: Microsoft YaHei, Microsoft YaHei !important;
									font-size: 18px;
									color: #000000;
									font-style: normal;
									margin: 0 auto;
									transition: color 0.8s !important;

									@media (max-width: 1200px) {
										// font-size: 14px;
										// top: 155px;
										// left: 90px;
									}

									@media (max-width: 800px) {
										font-size: 14px;
									}

									@media (max-width: 300px) {
										font-size: 13px;
									}
								}

								.click-box-buttom {
									width: 20px;
									height: 1px;
									margin: 10px auto 0;
									background: #9f1226;
									opacity: 0.73;
									transition: transform 0.5s ease;
									max-width: 100%;

									@media (max-width: 300px) {
										width: 15px;
									}
								}
							}

							.click-box:hover {
								.span-title {
									color: #bc0015;
								}

								img {
									transform: translateY(-10px);
								}

								.click-box-buttom {
									transform: translateY(5px);
								}
							}
						}
					}

					.products-span {
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						width: auto;
						height: 40px;
						color: #c11226;
						font-size: 30px;
						line-height: 40px;
						cursor: pointer;

						@media (max-width: 800px) {
							font-size: 25px;
						}
					}

					.products-header-left {
						position: relative;
						width: auto;
						height: 40px;
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						font-size: 30px;
						color: #000000;
						line-height: 40px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						margin-top: 2px;
						cursor: pointer;

						@media (max-width: 800px) {
							font-size: 25px;
						}
					}

					.products-header-bottom {
						display: -webkit-box;
						margin: 45px 0 22px 0;
						height: 26px;

						@media (max-width: 1440px) {
							display: none;
						}

						.mini-title {
							font-family: Microsoft YaHei, Microsoft YaHei !important;
							font-weight: 400;
							font-size: 20px !important;
							color: #151515;
							line-height: 30px;
							text-align: left;
							font-style: normal;
							text-transform: none;
							margin: 0 6px;
							cursor: pointer;

							@media (max-width: 800px) {
								font-size: 14px !important;
							}
						}
					}

					.mini-title-active {
						color: #d04f5d !important;
						font-weight: bold !important;
					}
				}

				.products-centent {
					width: 100%;
					height: auto;

					@media (max-width: 1600px) {
						width: 100%;
						max-width: 1440px;
						// height: 1500px;
						margin: 0 auto;
					}

					/* .products-centent-left {
          float: left;
          width: 700px;
          height: 436px;

          background-color: rgba($color: #fff, $alpha: 0.42);

          @media (max-width: 1600px) {
            width: 660px;
          }
          @media (max-width: 1440px) {
            width: 660px;
            float: none;
            margin: 0 auto;
          }
          @media (max-width: 1200px) {
            float: none;
            margin: 0 auto;
          }
          @media (max-width: 800px) {
            float: none;
            margin: 0 auto;
            width: 98%;
            height: 160px;
            max-width: 450px;
          }
          img {
            width: 100%;
            height: 100%;
          }
        } */
					.products-centent-left {
						position: relative;
						// display: flex;
						float: left;
						max-width: 750px;
						width: 50%;
						height: 436px;
						border: 1px solid #70707030;
						background-color: rgba($color: #fff, $alpha: 0.32);

						@media (max-width: 1440px) {
							float: none;
							max-width: none;
							width: 80%;
							margin: 80px auto 0;
						}

						@media (max-width: 1200px) {
							width: 90%;
						}

						@media (max-width: 800px) {
							max-width: 750px;
							width: 98%;
							height: 310px;
							margin-top: 55px;
						}

						.left-top-title {
							position: absolute;
							top: -57px;
							width: 163px;
							height: 57px;
							font-size: 20px;
							font-weight: bold;
							display: flex;
							justify-content: center;
							border: 1px solid #70707032;
							box-sizing: border-box;

							@media (max-width: 800px) {
								font-size: 16px;
								width: 100px;
								height: 42px;
								top: -41px;
							}

							.first {
								color: #000;
								margin: auto;
							}

							.last {
								color: #d04f5d;
								margin: auto auto auto 0;
							}
						}

						.centent {
							width: 100%;
							// height: 436px;
							background-color: rgba($color: #fff, $alpha: 0.32);
							line-height: 70px;

							// margin: 36px 0 0 31px;
							ul {
								margin: 0;
								padding-left: 30px;

								// width: 100%;
								// height: auto;
								@media (max-width: 800px) {
									padding-left: 0;
								}

								/* li:first-child {
                padding-top: 20px;
              } */
								li {
									list-style-type: none;
									max-width: 750px;
									width: 96%;
									height: 70px;
									font-family: Microsoft YaHei, Microsoft YaHei;
									font-weight: 400;
									font-size: 16px;
									color: #202020;
									cursor: pointer;

									@media (max-width: 1440px) {
										max-width: none;
										width: 98%;
									}

									@media (max-width: 800px) {
										max-width: 450px;
										width: 98%;
										height: 50px;
										font-size: 14px;
									}

									.left {
										width: 75%;
										float: left;
										overflow: hidden;
										/* 确保超出容器的内容被裁剪 */
										white-space: nowrap;
										/* 确保文本在一行内显示 */
										text-overflow: ellipsis;

										/* 超出部分显示省略号 */
										@media (max-width: 800px) {
											width: 50%;
											height: 50px;
											line-height: 50px;
											overflow: hidden;
											white-space: nowrap;
											text-overflow: ellipsis;
										}

										i {
											margin: 0 8px;
											font-family: Microsoft YaHei, Microsoft YaHei;
											font-weight: bold;
										}
									}

									.right {
										float: right;
										margin-right: 30px;

										@media (max-width: 800px) {
											margin-right: 10px;
											height: 50px;
											line-height: 50px;
										}
									}
								}
							}
						}

						.jump:hover {
							color: #cd0908;
						}

						.jump {
							position: absolute;
							top: 460px;
							left: 0;
							/* margin: 20px 0 0 0; */
							font-family: Microsoft YaHei, Microsoft YaHei !important;
							/* font-weight: bold; */
							font-size: 20px !important;
							font-weight: bold;
							color: #151515;
							line-height: 17px;
							cursor: pointer;
							transition: color 0.3s ease;

							@media (max-width: 1200px) {
								width: 100%;
							}

							@media (max-width: 800px) {
								max-width: 700px;
								top: 330px;
								font-size: 14px !important;
							}
						}

						.centent li:hover {
							font-weight: bold;
							color: #202020;
						}
					}

					.products-centent-right {
						position: relative;
						// display: flex;
						float: right;
						max-width: 750px;
						width: 48%;
						height: 436px;
						border: 1px solid #70707030;
						background-color: rgba($color: #fff, $alpha: 0.32);

						@media (max-width: 1440px) {
							float: none;
							max-width: none;
							width: 80%;
							margin: 160px auto 0;
						}

						@media (max-width: 1200px) {
							width: 90%;
						}

						@media (max-width: 800px) {
							max-width: 450px;
							width: 98%;
							height: 310px;
							margin-top: 100px;
						}

						.centent-top-title {
							position: absolute;
							display: flex;
							justify-content: center;
							align-items: center;
							width: 163px;
							height: 57px;
							box-sizing: border-box;
							// background-color: rgba(255, 255, 255, 0.32);
							font-family: Microsoft YaHei, Microsoft YaHei;
							font-weight: bold;
							font-size: 20px;
							color: #202020;
							line-height: 24px;
							border: 1px solid transparent;
							transition: border-color 0.8s ease;
							cursor: pointer;

							@media (max-width: 800px) {
								font-size: 16px;
								width: 100px;
								height: 42px;
							}
						}

						.location1 {
							left: -1px;
							top: -57px;

							@media (max-width: 800px) {
								top: -43px;
							}
						}

						.location2 {
							left: 162px;
							top: -57px;

							@media (max-width: 800px) {
								left: 100px;
								top: -43px;
							}
						}

						.location3 {
							left: 324px;
							top: -57px;

							@media (max-width: 800px) {
								left: 200px;
								top: -43px;
							}
						}

						.centent-top-title-active {
							color: #d04f5d;
							border-color: #70707032;
						}

						.centent {
							width: 100%;
							height: 436px;
							background-color: rgba($color: #fff, $alpha: 0.32);
							line-height: 70px;

							// margin: 36px 0 0 31px;
							ul {
								margin: 0;
								padding-left: 30px;

								// width: 100%;
								// height: auto;
								@media (max-width: 800px) {
									padding-left: 0;
								}

								/* li:first-child {
                padding-top: 20px;
              } */
								li {
									list-style-type: none;
									max-width: 750px;
									width: 96%;
									height: 70px;
									font-family: Microsoft YaHei, Microsoft YaHei;
									font-weight: 400;
									font-size: 16px;
									color: #202020;
									cursor: pointer;

									@media (max-width: 1440px) {
										max-width: none;
										width: 98%;
									}

									@media (max-width: 800px) {
										max-width: 450px;
										width: 98%;
										height: 50px;
										font-size: 14px;
									}

									.left {
										width: 75%;
										float: left;
										overflow: hidden;
										/* 确保超出容器的内容被裁剪 */
										white-space: nowrap;
										/* 确保文本在一行内显示 */
										text-overflow: ellipsis;

										/* 超出部分显示省略号 */
										@media (max-width: 800px) {
											width: 50%;
											height: 50px;
											line-height: 50px;
											overflow: hidden;
											white-space: nowrap;
											text-overflow: ellipsis;
										}

										i {
											margin: 0 8px;
											font-family: Microsoft YaHei, Microsoft YaHei;
											font-weight: bold;
										}
									}

									.right {
										float: right;
										margin-right: 30px;

										@media (max-width: 800px) {
											margin-right: 10px;
											height: 50px;
											line-height: 50px;
										}
									}
								}
							}
						}

						.jump:hover {
							color: #cd0908;
						}

						.jump {
							position: absolute;
							top: 460px;
							left: 0;
							/* margin: 20px 0 0 0; */
							font-family: Microsoft YaHei, Microsoft YaHei !important;
							/* font-weight: bold; */
							font-size: 20px !important;
							font-weight: bold;
							color: #151515;
							line-height: 17px;
							cursor: pointer;
							transition: color 0.3s ease;

							@media (max-width: 1200px) {
								width: 100%;
							}

							@media (max-width: 800px) {
								max-width: 700px;
								top: 330px;
								font-size: 14px !important;
							}
						}

						.centent li:hover {
							font-weight: bold;
							color: #202020;
						}
					}
				}
			}
		}

		.reports {
			// display: flex;
			// justify-content: center;
			width: 100%;
			max-width: 1600px;
			height: 790px;
			margin: 0 auto;

			@media (max-width: 1600px) {
				width: 90%;
				// max-width: 1336px;
				// height: 1500px;
				margin: 0 auto;
			}

			@media (max-width: 1440px) {
				// max-width: 1200px;
				width: 90%;
				// height: 1147px;
				margin: 77px auto 0;
			}

			@media (max-width: 1200px) {
				width: 100%;
				max-width: 770px;
				// height: 1147px;
				margin: 77px auto 0;
			}

			@media (max-width: 800px) {
				/* width: 98%; */
				max-width: 770px;
				height: 440px;
				margin: 10px auto 0;
			}

			.reports-title {
				width: 100%;
				height: 82px;

				.reports-header {
					@media (max-width: 800px) {
						width: 90%;
						margin: 0 auto;
					}

					height: 82px;
					position: relative;

					span {
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						width: auto;
						height: 40px;
						color: #c11226;
						font-size: 30px;
						line-height: 40px;
						cursor: pointer;

						@media (max-width: 800px) {
							font-size: 25px;
						}

						// margin-bottom: 2px;
					}

					.reports-header-left {
						width: auto;
						height: 40px;
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						font-size: 30px;
						color: #000000;
						line-height: 40px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						margin-top: 2px;
						cursor: pointer;

						@media (max-width: 800px) {
							font-size: 25px;
						}
					}
				}

				.reports-img {
					width: 100%;
					height: 635px;
					margin-top: 48px;
					cursor: pointer;
					display: flex;

					@media (max-width: 1440px) {
						// max-width: 1200px;
						width: 100%;
						margin: 48px auto 0;
						// transition: all 0.4s linear;
					}

					@media (max-width: 1200px) {
						max-width: 1200px;
						width: 100%;
						margin: 48px auto;
						// transition: all 0.4s linear;
					}

					@media (max-width: 800px) {
						width: 90%;
						height: 325px;
						margin: 15px auto;
						// transition: all 0.4s linear;
					}

					@media (max-width: 500px) {
						width: 90%;
					}

					.img-5 {
						width: 20%;
					}

					.img-4 {
						width: 25%;

						@media (max-width: 800px) {
							width: 50% !important;
							height: 325px;
							display: flex;
							flex-wrap: wrap;
							// transition: all 0.4s linear;
						}
					}

					.icon {
						width: 150px;
						height: 40px;
						display: flex;
						justify-content: center;
						margin: 34px auto 0;
						transition: transform 1s ease;
						max-width: 100%;
						opacity: 1 !important;

						@media (max-width: 800px) {
							width: 100%;
							display: inherit;
						}

						img {
							@media (max-width: 800px) {
								width: 20px;
								height: 20px;
							}
						}

						.title {
							width: auto;
							text-align: center;
							font-size: 20px;
							color: #fff;
							line-height: 65px;
							margin-left: 5px;

							@media (max-width: 800px) {
								font-size: 14px;
								line-height: 40px;
							}
						}
					}

					.brg-r:hover {
						opacity: 0.8;
					}

					.brg-r {
						background-repeat: no-repeat;
						background-size: cover;
						transition: opacity 1s ease;
						opacity: 1;
						background-color: #000000;

						@media (max-width: 1200px) {
							opacity: 1;
						}
					}
				}

				.brg-r:hover .icon {
					transform: translateY(-10px);
				}
			}
		}

		.research {
			position: relative;
			width: 100%;
			height: auto;

			@media (max-width: 1200px) {
				height: 655px;
				margin-bottom: 120px;
			}

			@media (max-width: 1440px) {
				margin-bottom: 20px;
			}

			@media (max-width: 800px) {
				margin-bottom: 0;
				height: 650px;
			}

			img {
				display: block;
				width: 100%;
				height: auto;
				position: absolute;
				top: -160px;

				// z-index: -1;
				@media (max-width: 1440px) {
					width: 100%;
					top: -100px;
					height: 300px;
					// display: flex;
					margin: auto;
					overflow: hidden;
				}

				@media (max-width: 1200px) {
					display: none;
				}

				@media (max-width: 800px) {
					display: none;
				}
			}

			.research-box {
				margin: 270px auto 0;
				position: relative;
				max-width: 1688px;
				width: 96%;
				height: 770px;
				z-index: 1000;
				background-color: #fff;

				// left: 0;
				// top: -1000px;
				@media (max-width: 1440px) {
					width: 95%;
					margin-top: 170px;
				}

				@media (max-width: 1200px) {
					width: 100%;
					margin-top: 0;
					// left: 0;
					// position: relative;
					// margin-top: 175px;
					// top: -1000px;
				}

				@media (max-width: 800px) {
					width: 90%;
					height: 650px;
				}

				background-color: #fff;

				.research-hander {
					@media (max-width: 1440px) {
						width: 1100px;
						margin: 60px auto 0;
						height: 90px;
					}

					@media (max-width: 1200px) {
						max-width: 770px;
						width: 100%;
						margin: auto;
						height: 70px;
					}

					@media (max-width: 800px) {
						max-width: 700px;
						width: 100%;
						margin: auto;
						// height: auto;
					}

					max-width: 1600px;
					width: 90%;
					height: 82px;
					margin: 0 auto 70px;
					// margin-left: 144px;
					// margin-top: 71px;
					position: relative;

					span {
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						float: left;
						width: 100%;
						height: 40px;
						margin-top: 70px;
						color: #c11226;
						font-size: 30px;
						line-height: 40px;
						cursor: pointer;

						@media (max-width: 800px) {
							font-size: 25px;
							margin-top: 0;
						}

						// margin-bottom: 2px;
					}

					.research-header-left {
						float: left;
						width: 65%;
						height: 40px;
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						font-size: 30px;
						color: #000000;
						line-height: 40px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						margin-top: 2px;
						cursor: pointer;

						@media (max-width: 1440px) {
							width: 50%;
						}

						@media (max-width: 1200px) {
							width: 35%;
						}

						@media (max-width: 800px) {
							width: 100%;
							font-size: 25px;
						}
					}

					.research-header-right {
						display: -webkit-box;
						// justify-content: flex-end;
						float: right;
						width: 35%;
						height: 26px;
						cursor: pointer;

						// @media (max-width: 1440px) {
						//   left: 665px;
						// }
						@media (max-width: 1440px) {
							width: 40%;
						}

						@media (max-width: 1200px) {
							width: 60%;
						}

						@media (max-width: 800px) {
							width: 98%;
							margin-top: 5px;
							margin-bottom: 15px;
							display: flex;
							flex-wrap: wrap;
						}

						@media (max-width: 300px) {
							margin-bottom: 45px;
						}

						.mini-title:hover {
							color: #d04f5d;
						}

						.mini-title {
							font-family: Microsoft YaHei, Microsoft YaHei !important;
							font-weight: 400;
							font-size: 20px !important;
							color: #151515;
							line-height: 30px;
							text-align: left;
							font-style: normal;
							text-transform: none;
							margin: 0 6px;
							transition: color 0.5s !important;

							@media (max-width: 800px) {
								font-size: 14px !important;
							}
						}
					}

					.mini-title-active {
						color: #d04f5d !important;
						font-weight: bold !important;
						transition: color 0.5s !important;
					}
				}

				.research-centent {
					max-width: 1600px;
					width: 90%;
					height: 375px;
					// margin-left: 124px;
					margin: 130px auto;

					@media (max-width: 1440px) {
						width: 1100px;
						margin: 130px auto;
					}

					@media (max-width: 1200px) {
						max-width: 770px;
						width: 100%;
						margin: 130px auto;
					}

					@media (max-width: 800px) {
						max-width: 700px;
						width: 100%;
						margin: 0 auto;
					}

					.jump:hover {
						color: #cd0908;
					}

					.jump {
						margin: 40px 0 0 0;
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						font-size: 20px !important;
						color: #151515;
						line-height: 17px;
						cursor: pointer;
						transition: color 0.3s ease;

						@media (max-width: 1200px) {
							width: 100%;
							// margin-top:70px;
						}

						@media (max-width: 800px) {
							max-width: 700px;
							margin: 25px 0 0 0;
							font-size: 14px !important;
						}
					}
				}
			}
		}

		.news {
			// max-width: 1600px;
			width: 100%;
			// height: 900px;
			margin: 0px auto 0;
			position: relative;
			top: -60px;

			@media (max-width: 1440px) {
				width: 100%;
				height: 1560px;
				// height: auto;
				// margin: 120px auto 0;
				position: relative;
				top: -60px;
			}

			@media (max-width: 1200px) {
				width: 100%;
				height: 1560px;
				// height: auto;
			}

			@media (max-width: 800px) {
				width: 100%;
				height: 100%;
				margin-top: 0px;
			}

			@media (max-width: 1440px) {
				width: 100%;
				height: 100%;
				margin-top: 100px;
			}

			.news-box {
				// max-width: 1440px;
				width: 100%;
				margin: 100px auto;
				/* height: 900px; */
				background-color: white;
				position: relative;

				@media (max-width: 1600px) {
					width: 100%;
					// max-width: 1440px;
					// height: 1500px;
					margin: 100px auto;
				}

				@media (max-width: 1440px) {
					width: 100%;
					// height: 1500px;
					margin: 100px auto;
				}

				@media (max-width: 1200px) {
					width: 100%;
					// height: 1500px;
					margin: 0 auto;
				}

				@media (max-width: 800px) {
					max-width: 700px;
					width: 90%;
					// height: 1500px;
					margin: 0 auto;
				}

				.news-header {
					@media (max-width: 1600px) {
						width: 90%;
						max-width: 1440px;
						// height: 1500px;
						margin: 0 auto;
					}

					@media (max-width: 1440px) {
						max-width: 1200px;
						margin: 0 auto;
						// width: 100%;
					}

					@media (max-width: 1200px) {
						// margin: 0 auto;
						// width: 770px;
					}

					@media (max-width: 800px) {
						margin: 0 auto;
						width: 98%;
						// height: 110px;
						// max-width: 350px;
						background: none;
					}

					max-width: 1600px;
					width: 100%;
					// height: 82px;
					margin: 0 auto;
					position: relative;

					span {
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						// width: 93px;
						width: 100%;
						float: left;
						height: 40px;
						color: #c11226;
						font-size: 30px;
						line-height: 40px;
						cursor: pointer;

						@media (max-width: 800px) {
							font-size: 25px;
						}
					}

					.news-header-left {
						// width: 120px;
						width: 60%;
						height: 40px;
						float: left;
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						font-size: 30px;
						color: #000000;
						line-height: 40px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						margin-top: 2px;
						cursor: pointer;

						@media (max-width: 1200px) {
							width: 44%;
							// float: left;
						}

						@media (max-width: 800px) {
							width: 100%;
							font-size: 25px;
							// float: left;
						}
					}

					.news-header-right {
						// position: absolute;
						display: -webkit-box;
						// left: 915px;
						// bottom: 0;
						width: 40%;
						float: left;
						// height: 26px;
						cursor: pointer;

						@media (max-width: 1200px) {
							width: 50%;
							// float: left;
						}

						@media (max-width: 800px) {
							width: 98%;
							margin-top: 5px;
							margin-bottom: 15px;
							display: flex;
							flex-wrap: wrap;
							// float: left;
						}

						// @media (max-width: 1000px) {
						//   position: absolute;
						//   display: -webkit-box;
						//   left: 420px;
						//   bottom: 0;
						// }
						// @media (max-width: 920px) {
						//   position: absolute;
						//   display: -webkit-box;
						//   left: 350px;
						//   bottom: 0;
						// }
						// @media (max-width: 820px) {
						//   position: absolute;
						//   display: -webkit-box;
						//   left: 285px;
						//   bottom: 0;
						// }
						.mini-title:hover {
							color: #d04f5d;
						}

						.mini-title {
							font-family: Microsoft YaHei, Microsoft YaHei;
							font-weight: 400;
							font-size: 20px !important;
							color: #151515;
							line-height: 30px;
							text-align: left;
							font-style: normal;
							text-transform: none;
							margin: 0 6px;
							transition: color 0.8s !important;

							@media (max-width: 800px) {
								font-size: 14px !important;
							}
						}
					}

					.mini-title-active {
						font-family: Microsoft YaHei, Microsoft YaHei;
						color: #d04f5d !important;
						font-weight: bold !important;
						transition: color 0.6s !important;
					}
				}

				.news-centent {
					// width: 1700px;
					width: 98%;
					height: 640px;
					margin: 77px auto;

					// background-color: #bc0015;
					@media (max-width: 1440px) {
						width: 100%;
						height: 1400px;
						margin-top: 77px;
						margin: 0 auto;
					}

					@media (max-width: 1200px) {
						width: 100%;
						height: 1400px;
						margin-top: 77px;
						margin: 0 auto;
					}

					@media (max-width: 800px) {
						max-width: 700px;
						height: 1000px;
						margin-top: 77px;
						margin: -20px auto 0;
					}

					.news-img {
						float: left;
						// max-width: 886px;
						width: 54%;
						height: auto;
						// margin-top: 77px;
						cursor: pointer;

						@media (max-width: 1440px) {
							max-width: 1000px;
							width: 100%;
							height: 636px;
							margin: 77px auto 0;
							float: none;
							// transition: all 0.4s linear;
						}

						@media (max-width: 1200px) {
							max-width: 882px;
							width: 100%;
							margin: 77px auto 0;
							float: none;
							// transition: all 0.4s linear;
						}

						@media (max-width: 800px) {
							max-width: 750px;
							width: 98%;
							height: 330px;
							margin: 40px auto 0;
							float: none;
							// transition: all 0.4s linear;
						}

						.news-img-content {
							position: relative;
							width: 98%;
							overflow: hidden;
							float: right;

							@media (max-width: 1600px) {
								width: 93%;
							}

							@media (max-width: 1440px) {
								float: none;
								margin: 0 auto;
							}

							@media (max-width: 1200px) {
								max-width: 750px;
								width: 100%;
								float: none;
							}

							@media (max-width: 800px) {
								width: 100%;
								float: none;
							}

							img {
								max-width: 1000px;
								width: 100%;
								height: 636px;
								float: right;

								@media (max-width: 1200px) {
									max-width: 750px;
									width: 100%;
								}

								@media (max-width: 800px) {
									// max-width: 450px;
									width: 100%;
									height: 330px;
								}
							}

							.img-box {
								position: absolute;
								max-width: 1000px;
								width: 100%;
								height: 157px;
								right: 0;
								bottom: 0;
								background-color: rgba($color: #000000, $alpha: 0.6);

								@media (max-width: 1600px) {
									width: 100%;
								}

								@media (max-width: 1440px) {
									max-width: none;
									width: 100%;
								}

								@media (max-width: 800px) {
									max-width: 750px;
									width: 100%;
									// text-align: center;
									line-height: 157px;
									bottom: -2px;
								}

								@media (max-width: 386px) {
									bottom: -32px;
								}

								.img-box-title {
									/* position: absolute; */
									/* left: 62px; */
									/* top: 24px; */
									margin: 20px 0 0 62px;
									width: 600px;
									height: 31px;
									font-family: Microsoft YaHei, Microsoft YaHei !important;
									font-weight: bold;
									font-size: 24px;
									text-align: left;
									color: #ffffff;
									line-height: 31px;
									white-space: nowrap;
									/* 确保文本在一行内显示 */
									overflow: hidden;
									/* 隐藏超出容器的文本 */
									text-overflow: ellipsis;

									/* 使用省略号表示被截断的文本 */
									@media (max-width: 800px) {
										width: 80%;
										left: 5px;
										top: 12px;
										margin: 0 auto;
										font-size: 18px;
										// bottom: 133px;
									}

									@media (max-width: 300px) {
										width: 70%;
										margin: 0 auto;
										// bottom: 133px;
									}
								}

								.img-box-centent {
									position: relative;
									width: 476px;
									height: 60px;
									font-family: Microsoft YaHei, Microsoft YaHei;
									font-weight: 400;
									font-size: 14px;
									color: #ffffff;
									line-height: 20px !important;
									margin: 20px 0 0 62px;
									overflow: hidden;
									text-overflow: ellipsis;

									@media (max-width: 800px) {
										max-width: 750px;
										width: 80%;
										height: 100px;
										margin: 30px auto 0;
										// bottom: 133px;
									}
								}
							}
						}
					}

					.news-card {
						width: 42%;
						height: 730px;
						float: right;
						box-sizing: border-box;

						// position: absolute;
						// top: 98px;
						// left: 946px;
						@media (max-width: 1440px) {
							width: 70%;
							margin: 50px auto 0;
							float: none;
							// top: 80px;
							// left: -70px;
						}

						@media (max-width: 1200px) {
							max-width: 750px;
							width: 100%;
							margin: 50px auto 0;
							float: none;
							// top: 80px;
							// left: -70px;
						}

						@media (max-width: 800px) {
							max-width: 700px;
						}

						.jump:hover {
							color: #cd0908;
						}

						.jump {
							margin: 40px 0 0 0;
							font-family: Microsoft YaHei, Microsoft YaHei !important;
							font-weight: 400;
							font-weight: bold;
							font-size: 20px;
							color: #151515;
							line-height: 17px;
							cursor: pointer;
							transition: color 0.5s !important;

							@media (max-width: 1200px) {
								width: 100%;
								// margin: 0 auto;
							}

							@media (max-width: 800px) {
								width: 98%;
								margin-top: 30px;
								font-size: 16px;
								margin-left: auto;
								margin-right: auto;
								font-size: 14px !important;
							}
						}
					}
				}

				.more {
					width: 129px;
					height: 44px;
					background: #c9a881;
					text-align: center;
					line-height: 44px;
					color: white;
					display: flex;
					justify-content: center;
					font-size: 14px;
					cursor: pointer;

					img {
						width: 20px;
						height: 20px;
						margin-top: 12px;
						margin-left: 10px;
						transition: all 0.3s linear;
					}

					&:hover {
						img {
							margin-left: 20px;
						}
					}
				}

				.content {
					width: 1000px;

					@media (max-width: 1199px) {
						width: 100%;
						flex-wrap: wrap;
						height: auto;
						margin-top: 0px;
					}

					height: auto;
					margin: auto;
					// position: absolute;
					margin-top: 20px;
					// background-color: red;
					display: flex;
					flex-wrap: wrap;

					.content1 {
						width: 1000px;
						margin-top: 50px;

						@media (max-width: 1199px) {
							width: 100%;
							flex-wrap: wrap;
							height: 200px;
							margin-top: 0px;
						}

						.num {
							width: 25%;
							height: 100px;
							text-align: center;
							transition: all 0.4s linear;

							@media (max-width: 1199px) {
								width: 50%;
							}

							:last-child {
								// line-height: 50px;
								font-size: 16px;
								cursor: pointer;

								@media (max-width: 1199px) {
									font-size: 12px;
								}

								font-weight: normal;
								color: #c9a881;
							}
						}
					}

					.left {
						width: 450px;

						@media (max-width: 1199px) {
							width: 100%;
							height: auto;
						}

						.title-en {
							font-size: 18px;
							font-family: Italic;
							font-weight: normal;
							color: #c5a176;

							@media (max-width: 1199px) {
								margin-top: 30px;
							}
						}
					}

					.right {
						width: 550px;

						@media (max-width: 1199px) {
							width: 100%;
							height: 300px;
						}

						height: auto;
						position: relative;

						img {
							width: 90%;
							height: 390px;
							margin-left: 10%;
							margin-top: 110px;
							transition: all 0.4s linear;
							cursor: pointer;

							@media (max-width: 1199px) {
								height: 240px;
								width: 100%;
								margin-left: 0%;
								margin-top: 30px;
							}
						}

						.right-num {
							position: absolute;
							right: -100px;
							bottom: 35%;
							width: 200px;
							height: 100px;
							line-height: 50px;
							text-align: right;
							transition: all 0.4s linear;
							cursor: pointer;

							@media (max-width: 1199px) {
								display: none;
							}

							:first-child {
								font-size: 31px;
								font-family: Italic;
								font-weight: normal;
								color: #c5a176;
							}

							:last-child {
								font-size: 71px;
								font-family: Italic;
								font-weight: normal;
								color: #c5a176;
							}
						}
					}
				}
			}
		}

		ul {
			margin: 0 0;
		}

		.driendship {
			max-width: 1600px;
			width: 100%;
			// overflow: hidden;
			// height: 300px;
			margin: 100px auto;

			@media (max-width: 1440px) {
				width: 90%;
				// margin: 50px auto 0;
				margin-top: -100px;
			}

			// @media (max-width: 1200px) {
			//   width: 100%;
			// }
			@media (max-width: 800px) {
				width: 100%;
				margin: -68px 0 -70px 0;
			}

			.driendship-box {
				width: 100%;
				// overflow: hidden;
				background-color: #fff;

				.ContactUs {
					display: flex;
					justify-content: space-between;
					position: relative;

					@media (max-width: 1440px) {
						margin-bottom: 100px;
					}

					.right {
						width: 26%;
						background: url("../assets/shj/Contact.png") no-repeat;
						padding: 40px 40px;
						position: absolute;
						height: 100%;
						top: -86px;
						z-index: 99;

						@media (max-width: 800px) {
							width: 75% !important;
							margin: 0 auto;
							height: 150px !important;
							position: static;
							// margin-bottom: 40px;
							margin-top: -40px;
						}

						@media (max-width: 1440px) {
							width: 40%;
							// margin: 0 auto;
							height: 400px;
							position: static;
							// margin-bottom: 40px;
							margin-top: -40px;
							z-index: 99;
						}

						.right-bottom {
							display: flex;
							align-items: center;
							color: white;
							justify-content: space-between;
							margin-top: 40px;
						}

						.right-bottom-center {
							flex: 1;
							margin-left: 16px;
						}
					}

					.left {
						width: 70%;
						margin-left: 30%;

						@media (max-width: 800px) {
							display: none;
						}

						@media (max-width: 1440px) {
							margin-left: 0%;
							width: 70%;
							bottom: 0;
							position: absolute;
							right: 0;
							z-index: 1;
						}

						img {
							object-fit: cover;
							width: 100%;
						}
					}
				}

				.driendship-hander {
					@media (max-width: 1600px) {
						width: 100%;
						max-width: 1440px;
						// height: 1500px;
						margin: 0 auto;
					}

					@media (max-width: 1440px) {
						width: 100%;
						max-width: 1200px;
						// height: 1500px;
						margin: 0 auto;
					}

					@media (max-width: 1200px) {
						max-width: 770px;
						margin: 0 auto;
					}

					@media (max-width: 800px) {
						width: 90%;
						margin: 0 auto;
					}

					height: 82px;
					// margin-left: 144px;
					margin-top: 50px;
					position: relative;

					span {
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						width: 93px;
						height: 40px;
						color: #c11226;
						font-size: 30px;
						line-height: 40px;
						cursor: pointer;

						@media (max-width: 800px) {
							font-size: 25px;
						}

						// margin-bottom: 2px;
					}

					.driendship-header-left {
						width: 120px;
						height: 40px;
						font-family: Microsoft YaHei, Microsoft YaHei !important;
						font-weight: bold;
						font-size: 30px;
						color: #000000;
						line-height: 40px;
						text-align: left;
						font-style: normal;
						text-transform: none;
						margin-top: 2px;
						cursor: pointer;

						@media (max-width: 800px) {
							font-size: 25px;
						}
					}
				}

				.driendship-centent {
					// width: 90%;
					max-width: 1200px;
					min-height: 400px;
					overflow: hidden;
					display: flex;
					flex-wrap: wrap;
					justify-content: center;
					margin: 0 auto;
					/* margin-left: 144px; */
					padding: 50px 0 50px;

					@media (max-width: 1600px) {
						width: 100%;
						max-width: 1440px;
						// height: 1500px;
						/* margin: 50px auto 0; */
						padding: 50px 0;
					}

					@media (max-width: 1440px) {
						margin: 0 auto;
					}

					@media (max-width: 1200px) {
						max-width: 700px;
						margin: 0 auto;
						padding: 50px 0;
					}

					@media (max-width: 800px) {
						width: 90%;
						padding-top: 0;
						padding-bottom: 0;
					}

					.mini-size:hover img {
						transform: translateY(-10px);
					}

					.mini-size {
						/* float: left; */
						height: 155px;
						width: 218px;
						margin: 0 30px;
						cursor: pointer;
						display: flex;
						justify-content: center;
						align-items: center;

						@media (max-width: 800px) {
							float: none;
							width: 150px;
							height: 100px;
							margin: 0 auto;
						}

						@media (max-width: 300px) {
							float: none;
							width: 120px;
						}

						img {
							width: 200px;
							transition: transform 0.5s ease;
							max-width: 100%;

							@media (max-width: 800px) {
								width: 150px;
							}
						}
					}
				}
			}
		}
	}

	.Core-boxs {
		width: 80% !important;
	}

	.Core-boxs2 {
		width: 20% !important;
	}
</style>


// WEBPACK FOOTER //
// src/views/index.vue